<template>
  <v-card>
    <v-card-text>
      <salvar-agendamento-envio-mensagem-dialog
        :is-dialog-open.sync="isCriarAgendamentoMensagemDialogOpen"
        :grupos-contatos-ids-inicial="gruposContatosIdsParaNovoAgendamento"
        @refetch-data="getAgendamentos"
      />

      <v-row>
        <v-col cols="12">
          <counter
            :loading="isGetContadoresLoading"
            :counters="contadores"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="auto">
          <v-select
            v-model.trim="agendamentoMensagemStatusSelecionados"
            dense
            outlined
            hide-details
            label="Filtrar por status"
            placeholder="Filtrar por status"
            item-text="nome"
            item-value="id"
            multiple
            clearable
            :items="agendamentosStatus"
            @change="getAgendamentos"
          />
        </v-col>

        <v-spacer></v-spacer>

        <v-col cols="auto">
          <v-btn
            color="success"
            @click.stop="isCriarAgendamentoMensagemDialogOpen = !isCriarAgendamentoMensagemDialogOpen"
          >
            <v-icon
              left
              size="25"
            >
              {{ icons.mdiAccountPlusOutline }}
            </v-icon>

            <span>Criar Agendamento</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <table-agendadamentos-envios-em-massa
            :items="agendamentos"
            :loading="isGetAgendamentosLoading"
            @refetch-data="getAgendamentos"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
import { mdiCloseCircle, mdiSend, mdiGiftOpenOutline, mdiGiftOffOutline, mdiCheckBold, mdiDelete, mdiGestureTap, mdiCheckOutline, mdiAccountPlusOutline } from '@mdi/js'
import Counter from '@/components/contadores/Counter.vue'
import SalvarAgendamentoEnvioMensagemDialog from '@/views/envio-em-massa/agendamento-envio-mensagem/SalvarAgendamentoEnvioMensagemDialog.vue'
import TableAgendadamentosEnviosEmMassa from '@/components/tables/TableAgendadamentosEnviosEmMassa.vue'
import AgendamentoEnvioMensagemStatusEnum from '@/models/entities/agendamento-envio-mensagem/AgendamentoEnvioMensagemStatusEnum'
import AgendamentoMensagensService from '@/services/modules/AgendamentoMensagensService'
import { useRouter } from '@/@core/utils'

export default {
  components: {
    Counter,
    SalvarAgendamentoEnvioMensagemDialog,
    TableAgendadamentosEnviosEmMassa,
  },

  setup() {
    const isCriarAgendamentoMensagemDialogOpen = ref(false)
    const gruposContatosIdsParaNovoAgendamento = ref([])

    const { route } = useRouter()

    const isGetAgendamentosLoading = ref(false)
    const isGetContadoresLoading = ref(false)

    const agendamentos = ref([])
    const contadores = ref([
      { title: 'Enviadas', quantity: 0, icon: { color: 'primary', shape: mdiSend } },
      { title: 'Entregues', quantity: 0, icon: { color: 'success', shape: mdiGiftOpenOutline } },
      { title: 'Lidas', quantity: 0, icon: { color: 'accent', shape: mdiCheckBold } },
      { title: 'Clicadas', quantity: 0, icon: { color: '#8e117b', shape: mdiGestureTap } },
      { title: 'Verificadas', quantity: 0, icon: { color: '#8e117b', shape: mdiCheckOutline } },
      { title: 'Rejeitadas', quantity: 0, icon: { color: 'error', shape: mdiCloseCircle } },
      { title: 'Não entregues', quantity: 0, icon: { color: 'error', shape: mdiGiftOffOutline } },
      { title: 'Apagadas', quantity: 0, icon: { color: 'error', shape: mdiDelete } },
    ])

    const agendamentosStatus = ref([
      {
        id: AgendamentoEnvioMensagemStatusEnum.Rascunho,
        nome: 'Rascunho',
      },
      {
        id: AgendamentoEnvioMensagemStatusEnum.Agendado,
        nome: 'Agendado',
      },
      {
        id: AgendamentoEnvioMensagemStatusEnum.EmProcessamento,
        nome: 'Em processamento',
      },
      {
        id: AgendamentoEnvioMensagemStatusEnum.Processado,
        nome: 'Processado',
      }])

    const agendamentoMensagemStatusSelecionados = ref([AgendamentoEnvioMensagemStatusEnum.Agendado, AgendamentoEnvioMensagemStatusEnum.EmProcessamento])

    async function getAgendamentos() {
      if (isGetAgendamentosLoading.value) return

      try {
        isGetAgendamentosLoading.value = true
        agendamentos.value = await AgendamentoMensagensService.get()

        if (agendamentoMensagemStatusSelecionados.value.length) {
          agendamentos.value = agendamentos.value.filter(it => agendamentoMensagemStatusSelecionados.value.includes(it.statusId))
        }
      } finally {
        isGetAgendamentosLoading.value = false
      }
    }

    async function getContadores() {
      if (isGetContadoresLoading.value) return

      try {
        isGetContadoresLoading.value = true

        const res = await AgendamentoMensagensService.getContadores()

        contadores.value[0].quantity = res.qtdMensagensEnviadas
        contadores.value[1].quantity = res.qtdMensagensEntregues
        contadores.value[2].quantity = res.qtdMensagensLidas
        contadores.value[3].quantity = res.qtdMensagensClicadas
        contadores.value[4].quantity = res.qtdMensagensVerificadas
        contadores.value[5].quantity = res.qtdMensagensRejeitadas
        contadores.value[6].quantity = res.qtdMensagensNaoEntregues
        contadores.value[7].quantity = res.qtdMensagensApagadas
      } finally {
        isGetContadoresLoading.value = false
      }
    }

    onMounted(async () => {
      const grupoContatoId = route.value?.query?.grupoContatoId
      if (grupoContatoId) {
        gruposContatosIdsParaNovoAgendamento.value = [Number(grupoContatoId)]
        isCriarAgendamentoMensagemDialogOpen.value = true
      }

      await getContadores()
      await getAgendamentos()
    })

    return {
      isCriarAgendamentoMensagemDialogOpen,
      gruposContatosIdsParaNovoAgendamento,
      isGetAgendamentosLoading,
      isGetContadoresLoading,
      agendamentos,
      contadores,
      agendamentosStatus,
      agendamentoMensagemStatusSelecionados,
      getAgendamentos,
      icons: {
        mdiAccountPlusOutline,
      },
    }
  },
}
</script>
